<template>
	<div id="switchAccountModal" class="modal" role="dialog">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<!-- <div> -->
					<span></span>
					<h3 class="uptext">Switch Accounts</h3>
					<!-- </div> -->
					<button class="close-btn" @click="$emit('close')">x</button>
				</div>
				<div class="modal-body">
					<div class="user-accounts-contianer">
						<div class="user-account-details">
							<div class="avatar">
								<img src="../assets/images/ava-1.jpg" alt="Ava Max" />
							</div>
							<div class="user-informations">
								<span class="username">{{ name }}</span>
								<span class="user-email">{{ email }}</span>
							</div>
							<div class="active-account">
								<img src="../assets/images/check.png" alt="Check mark" />
							</div>
						</div>
						<div class="user-account-details">
							<div class="avatar">
								<img src="../assets/images/ava-1.jpg" alt="Ava Max" />
							</div>
							<div class="user-informations">
								<span class="username">Admin User</span>
								<span class="user-email">admin@team.com</span>
							</div>
						</div>
						<div class="user-account-details">
							<div class="avatar">
								<img src="../assets/images/ava-1.jpg" alt="Ava Max" />
							</div>
							<div class="user-informations">
								<span class="username">Admin User</span>
								<span class="user-email">admin@team.com</span>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="another-account-login-btn">
						Log into an Existing Account
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Loading from "vue-loading-overlay";
// import "vue-loading-overlay/dist/vue-loading.css";
import { getUserEmail, getLastName, getFirstName } from "../utils/auth";
// import Auth from "@aws-amplify/auth";
// import Amplify from "@aws-amplify/core";
// import ChangePassword from "./ChangePassword";

export default {
	name: "ResetPassword",
	props: ["showing"],
	data() {
		return {
			// oldPassword: null,
			// // email: getUserEmail(),
			// isLoading: false,
			// fullPage: true,
			// dismissSecs: 5,
			// dismissCountDown: 0,
			// err: "",
			// isChangePassword: false
			email: getUserEmail(),
			name: `${getFirstName()} ${getLastName()}`
		};
	},
	// components: {
	// 	Loading,
	// 	ChangePassword
	// },
	mounted() {},
	methods: {
		// countDownChanged(dismissCountDown) {
		// 	this.dismissCountDown = dismissCountDown;
		// },
		// resetPassword() {
		// 	this.isLoading = true;
		// 	setTimeout(() => {
		// 		this.isLoading = false;
		// 		this.isChangePassword = true;
		// 	}, 1000);
		// 	// Auth.forgotPassword(this.email)
		// 	//   .then((data) => {
		// 	//     // console.log(data);
		// 	//     this.isChangePassword = true;
		// 	//     //this.$router.push({ name: 'reset' , query : {email : this.email}})
		// 	//   })
		// 	//   .catch((err) => {
		// 	//     this.isLoading = false;
		// 	//     console.log(err);
		// 	//     this.err = err.message;
		// 	//     this.dismissCountDown = this.dismissSecs;
		// 	//   });
		// }
	}
};
</script>
